import { render, staticRenderFns } from "./UserBrowser.vue?vue&type=template&id=7890c0d3"
import script from "./UserBrowser.vue?vue&type=script&lang=ts"
export * from "./UserBrowser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports